import React from 'react';

import Header from '../../Components/Header';

import Sidebar from '../../Components/Sidebar';

import PageHeader from '../../Components/PageHeader';

import WinesTable from '../../Components/Table/WinesTable';

import axios from 'axios';


export default function Wines() {
  const [winesTable, setWinesTable] = React.useState(null);
  // ...
  React.useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/wines`)
      .then((response) => {
        setWinesTable(response.data);
      });
  }, []);
  // ...
  const columns = React.useMemo(
    () => [

      {
        Header: 'Nome',
        accessor: 'nome',
      },
      {
        Header: 'Estado',
        accessor: 'estado',
      },
      {
        Header: 'Preço',
        accessor: 'preco',
        Footer: (info: any) => {
          const total = React.useMemo(
            () =>
              info.rows.reduce((sum: any, row: any) => Number(row.values.preco) * row.values.quantidade + sum, 0),
            [info.rows]
          )
          return <>{total}</>
        },
      },
      {
        Header: 'Data de Compra',
        accessor: 'dataCompra',
      },
      {
        Header: 'Qtd',
        accessor: 'quantidade',
        Footer: (info: any) => {
          const total = React.useMemo(
            () =>
              info.rows.reduce((sum: any, row: any) => row.values.quantidade + sum, 0),
            [info.rows]
          )
          return <>{total}</>
        },
      },
      {
        Header: 'Região',
        accessor: 'regiao',
      },
      {
        Header: 'Ações',
        accessor: 'id',
        disableFilters: true,


        Cell: (row: any) => {
          const editItem = (value: any) => {
            window.location.href = `/wines/edit/${row.value}`
          };
          const deleteItem = () => {
            axios.delete(`${process.env.REACT_APP_API_URL}/wines/${row.value}/`).then((res) => {
              if (res.data) {
                window.location.href = '/wines';
              }
            });
          };
          return (
            <div>
              <button
                onClick={editItem}
                className="bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white py-1 px-1 border border-blue-500 hover:border-transparent rounded mr-2"
              >
                Editar
              </button>
              <button
                onClick={deleteItem}
                className="bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white py-1 px-1 border border-blue-500 hover:border-transparent rounded mr-2"
              >
                Excluir
              </button>
            </div>
          );
        },
      },
    ],
    [],
  );

  return (
    <div className="flex">
      <Sidebar />
      <div className="content">
        <Header />
        <PageHeader
          title="Lista de Vinhos"
          RigthActionButtonTitle="Incluir Novo Vinho"
          RigthActionButtonRoute={'/wines/create'}
        />
        <div className={'my-8'}>
          <a className={'intro-y bg-dark-2 text-white text-center whitespace-nowrap my-8 p-4 shadow-md'} href={window.location.origin + '/wines/filter'}>Personalizar Filtro</a>
        </div>
        <div className="mt-8">
          {winesTable ? <WinesTable columns={columns} data={winesTable} /> : null}

        </div>
      </div>
    </div>
  );
}




